<div
    animate.enter="tooltip-in"
    class="flex gap-2 items-center bg-black text-gray-800 text-sm shadow-md rounded-md p-4 relative"
>
    <div class="absolute left-6 -bottom-2 w-5 h-5 bg-black rotate-45"></div>
    <div class="absolute inset-0 bg-black rounded-md"></div>
    <div class="relative flex gap-2 items-center w-full">
        <div class="text-sm text-white">
            <ng-content />
        </div>
        @if (!disableClose()) {
            <app-icon
                name="mdi:close"
                class="text-zinc-300 cursor-pointer"
                size="sm"
                (click)="close.emit()"
            />
        }
    </div>
</div>
